import {
  neutral1,
  primary,
  primaryDark2,
  primaryDivider,
  primaryLight2,
  red,
  redDark,
  redLight,
  secondary,
  secondaryDark,
  secondaryLight,
  themeGrey,
  white,
} from './colors';

const palette = {
  mode: 'light',
  primary: {
    light: primaryLight2,
    main: primary,
    dark: primaryDark2,
  },
  secondary: {
    light: secondaryLight,
    main: secondary,
    dark: secondaryDark,
  },
  grey: themeGrey,
  error: {
    light: redLight,
    main: red,
    dark: redDark,
  },
  background: {
    default: neutral1,
    paper: white,
  },
  divider: primaryDivider,
};

export default palette;
